module.exports = __webpack_public_path__ + "img/ffe108393b0edc49e96ff007f82519ed.png";